import * as T from '@/types'

import { CrudResource } from '@/api/resources/api-crud'

const routes : {[key: string] : string} = {
    Index: 'creditor/files',
    Show: 'creditor/files/${id}',
    Download: 'creditor/files/download',
}

export class FilesResource extends CrudResource<T.File>{

    get crudBaseCalls () {
        const api = this.api

        return {
            index (filters?: T.Filters, queryParams?: any) {
                return api.get(routes.Index, { params: { limit: 20, ...queryParams, ...filters}})
            },
            page (pageRoute: string) {
                return api.get(pageRoute)
            },
            show (id : T.EntityId) { 
                return api.get(routes.Show.replace('${id}', id))  
            },
            // store (chatProfile: Partial<T.File>) {
            //     return api.post(api.route(routes.Store), chatProfile)
            // },
            // update (chatProfile: T.File) {
            //     return api.patch(api.route(routes.Update, {chatProfileId: chatProfile.id }), chatProfile)
            // },
            // delete (chatProfile: T.File) {
            //     return api.delete(api.route(routes.Delete, { chatProfileId: chatProfile.id }))
            // },
            // restore (chatProfile: T.File) {
            //     return api.patch(api.route(routes.Restore, { chatProfileId: chatProfile.id }))
            // },
        }
    }

    async download (fileIds: T.FileId[], redirect: boolean = true): Promise<string | undefined> {
        const response = await this.api.get(routes.Download, {params: {files: fileIds}})
        const { url, zipRef } = response.data.data
        if (fileIds.length === 1) {
            console.log('Opening single download URL:', url)

            if (redirect) window.location.href = url
            return url
        } else {
            console.log('Zipping multiple files.')

            const zipUrl = await this.ping(zipRef, 2000, 40000)
            if (zipUrl) {
                console.log( 'Opening zipUrl: ' , zipUrl )
                if (redirect) window.location.href = zipUrl
                return zipUrl
            }
        }
    }

    async ping (zipRef: string, frequency: number, timeout: number): Promise<string | null> {
        if (timeout <= 0 || frequency > timeout) return null
        console.log('Pinging zipref...')

        let response = await this.api.get(routes.Download, { params: { zipRef } })
        if (response.status === 204) {
            await new Promise((resolve) => setTimeout(resolve, frequency))
            return await this.ping(zipRef, frequency, timeout - frequency)
        } else if (response.status === 200) {
            return response.data.data.url
        }
        return null
    }

    item (data: any) {
        return data
    }

    items (data: any) {
        return data
    }

    map (data: any) {
        return {
            case: data.case,
            createdAt: data.createdAt,
            creditor: data.creditor,
            description: data.description,
            downloadedAt: data.downloadedAt,
            fileName: data.fileName,
            fileUrl: data.fileUrl,
            id: data.id,
            mimeType: data.mimeType,
            name: data.name,
            source: data.source,
            tags: data.tags,
            type: data.type,
            updatedAt: data.updatedAt,
        }
    }

}

export default function (api: T.CreditorDeskApi, downloadApi?: any) {
    return new FilesResource(api)
}
